const RefundPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6 text-center">Returns and Refund Policy</h1>

      {/* 48-hour Unwanted */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">48-hour Unwanted Returns</h2>
        <p>
          We offer a unique <strong>48-hour returns policy</strong> where you can return an unwanted item within
          48 hours of purchase for a full refund in the form of a durapot voucher.  
        </p>
        <p className="mt-2">
          Refunds are subject to the following conditions:
        </p>
        <ul className="list-disc list-inside ml-4 mt-2">
          <li>The item must be in the same condition as sold.</li>
          <li>The item will be tested before a refund is processed.</li>
          <li>No cash or card refunds will be provided under any circumstances.</li>
        </ul>
        <p className="mt-2">
          durapot reserves the right to limit the number of unwanted refunds and may refuse to honor this policy
          to prevent misuse or abuse by you or your affiliates. This policy is a goodwill gesture and does not
          form part of your legal rights.
        </p>
      </section>

      {/* 24-Months Warranty */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">24-Months Warranty</h2>
        <p>
          We offer a <strong>24-month warranty</strong> on all items except consumables. Consumables (e.g., batteries) are covered for
          <strong> 28 days</strong> only.
        </p>
        <p className="mt-2">
          The warranty does NOT cover:
        </p>
        <ul className="list-disc list-inside ml-4 mt-2">
          <li>Physical damage</li>
          <li>Liquid damage</li>
          <li>Damage caused by rooting or jailbreaking a device</li>
          <li>Damage due to misuse or unauthorized repair attempts</li>
        </ul>
        <p className="mt-2">
          If a product develops a fault within 24 months of sale, we will:
        </p>
        <ul className="list-disc list-inside ml-4 mt-2">
          <li>First attempt to repair the product.</li>
          <li>
            If we are unable to repair the product, we will offer a replacement or a refund (whichever is
            applicable).
          </li>
          <li>
            The refund will be processed based on the current or original value of the item (whichever is
            lower), as per company policy.
          </li>
        </ul>
      </section>

      {/* Final Note */}
      <p className="mt-8 text-gray-600 text-center">
        Please contact our support team if you have any questions or need further assistance.
      </p>
    </div>
  );
};

export default RefundPolicy;
